module.exports = __webpack_public_path__ + "img/employee-operation.cf63da9c.jpg";